import SolicitudService from 'src/modules/solicitud/solicitudService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'SOLICITUD_VIEW';

const solicitudViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: solicitudViewActions.FIND_STARTED,
      });

      const record = await SolicitudService.find(id);

      dispatch({
        type: solicitudViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: solicitudViewActions.FIND_ERROR,
      });

      getHistory().push('/solicitud');
    }
  },
};

export default solicitudViewActions;
